import AxiosAPI from '../../../utils/AxiosAPI';

export const handlePackageOpe = (authInfo, dateStart, dateEnd, q) =>
    new Promise((resolve, reject) => {
        AxiosAPI(authInfo)
            .setPath(`/api/contract/package/list/`, {
                dateStart,
                dateEnd,
                q
            })
            .get()
            .then(({ data }) => {
                if (data.error === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.message));
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

export default null;
